import { useRef, useEffect } from 'react';

function useClickOutside<T extends HTMLElement>(
  func: () => void,
  shouldBind = true
) {
  const ref = useRef<T>(null);
  function handleClickOutside(event: MouseEvent) {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      func();
    }
  }

  useEffect(() => {
    if (shouldBind) {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBind]);

  return { ref };
}

export default useClickOutside;
